import { combineReducers } from 'redux'
import global from './global'
import theme from './theme'
import call from './calls'
import { connectRouter, routerMiddleware } from 'connected-react-router'

export default (history) => combineReducers({
  theme,
  call,
  global,
  router: connectRouter(history)
})
